import { useDispatch } from 'react-redux';

import { AppDispatch } from './store';
import { Loading, Config, ErrorMessage, ErrorPopup, SuccessMessage } from './types';
import { uiActions } from './ui-slice';

export default function Helper() {
  const dispatch: AppDispatch = useDispatch();

  function triggerLoading(payload: Loading) {
    return dispatch(uiActions.triggerLoading(payload));
  }

  function setConfig(payload: Config) {
    return dispatch(uiActions.setConfig(payload));
  }

  function setErrorMessage(payload: ErrorMessage) {
    return dispatch(uiActions.setErrorMessage(payload));
  }

  function setErrorPopup(payload: ErrorPopup) {
    return dispatch(uiActions.setErrorPopup(payload));
  }

  function setSuccessMessage(payload: SuccessMessage) {
    return dispatch(uiActions.setSuccessMessage(payload));
  }

  return {
    triggerLoading,
    setConfig,
    setErrorMessage,
    setErrorPopup,
    setSuccessMessage,
  };
}
